/* Kodiak Storefronts Landing Page — Vanilla JS */

(function () {
  'use strict';

  var CTA_URL = 'https://app.livedesigner.ai/request-store/kodiak';
  var SPOTS_LEFT = 23;

  /* ─── Hide theme chrome ─── */

  ['#shopify-section-header', '#shopify-section-footer',
   '#shopify-section-shipping-bar', '#shopify-section-shipping_bar',
   '#shopify-section-announcement-bar', '#shopify-section-cart-drawer',
   '.mega-menu-container', '.site-overlay'].forEach(function (sel) {
    var el = document.querySelector(sel);
    if (el) el.style.display = 'none';
  });
  document.querySelectorAll('.shopify-section-group-header-group, .shopify-section-group-footer-group').forEach(function (el) {
    el.style.display = 'none';
  });

  /* ─── Scroll Reveal ─── */

  function initReveal() {
    var els = document.querySelectorAll('.sf-reveal');
    if (!els.length) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var delay = parseFloat(entry.target.dataset.delay) || 0;
          if (delay > 0) {
            setTimeout(function () {
              entry.target.classList.add('sf-visible');
            }, delay * 1000);
          } else {
            entry.target.classList.add('sf-visible');
          }
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    els.forEach(function (el) { observer.observe(el); });
  }

  /* ─── Counter Animation ─── */

  function initCounters() {
    var counters = document.querySelectorAll('[data-counter]');
    if (!counters.length) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && !entry.target.dataset.started) {
          entry.target.dataset.started = 'true';
          var end = parseInt(entry.target.dataset.counter, 10);
          var suffix = entry.target.dataset.suffix || '';
          var duration = 1800;
          var t0 = performance.now();

          function tick(now) {
            var p = Math.min((now - t0) / duration, 1);
            var eased = 1 - Math.pow(1 - p, 3);
            var val = Math.round(eased * end);
            entry.target.textContent = val.toLocaleString() + suffix;
            if (p < 1) requestAnimationFrame(tick);
          }

          requestAnimationFrame(tick);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.3 });

    counters.forEach(function (el) { observer.observe(el); });
  }

  /* ─── Sticky Nav ─── */

  function initNav() {
    var nav = document.querySelector('.sf-nav');
    if (!nav) return;

    window.addEventListener('scroll', function () {
      if (window.scrollY > 50) {
        nav.classList.add('sf-scrolled');
      } else {
        nav.classList.remove('sf-scrolled');
      }
    });
  }

  /* ─── FAQ Accordion ─── */

  function initFaq() {
    var items = document.querySelectorAll('.sf-faq-item');
    items.forEach(function (item) {
      var btn = item.querySelector('.sf-faq-question');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var isOpen = item.classList.contains('sf-open');
        items.forEach(function (i) { i.classList.remove('sf-open'); });
        if (!isOpen) item.classList.add('sf-open');
      });
    });
  }

  /* ─── Hero Word Cycler ─── */

  function initHeroCycle() {
    var el = document.getElementById('sf-hero-cycle');
    if (!el) return;

    var words = ['business', 'school', 'brand', 'gym', 'fundraiser', 'team', 'church', 'brewery'];
    var idx = 0;
    var INTERVAL = 2400;
    var ANIM_MS = 350;

    setInterval(function () {
      el.classList.add('sf-cycle-out');

      setTimeout(function () {
        idx = (idx + 1) % words.length;
        el.textContent = words[idx];
        el.classList.remove('sf-cycle-out');
        el.classList.add('sf-cycle-in');

        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            el.classList.remove('sf-cycle-in');
          });
        });
      }, ANIM_MS);
    }, INTERVAL);
  }

  /* ─── Sticky Bottom Bar ─── */

  function initStickyBar() {
    var bar = document.getElementById('sf-sticky-bar');
    var hero = document.querySelector('.sf-hero');
    if (!bar || !hero) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          bar.classList.remove('sf-sticky-visible');
        } else {
          bar.classList.add('sf-sticky-visible');
        }
      });
    }, { threshold: 0 });

    observer.observe(hero);
  }

  /* ─── Hamburger Mobile Menu ─── */

  function initHamburger() {
    var btn = document.querySelector('.sf-hamburger');
    var menu = document.querySelector('.sf-mobile-menu');
    if (!btn || !menu) return;

    btn.addEventListener('click', function () {
      var isOpen = btn.classList.toggle('sf-hamburger-open');
      menu.classList.toggle('sf-mobile-menu-open');
      btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });

    menu.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        btn.classList.remove('sf-hamburger-open');
        menu.classList.remove('sf-mobile-menu-open');
        btn.setAttribute('aria-expanded', 'false');
      });
    });
  }

  /* ─── Product Card Tilt ─── */

  function initCardTilt() {
    var cards = document.querySelectorAll('.sf-product-card');
    if (!cards.length || window.matchMedia('(hover: none)').matches) return;

    cards.forEach(function (card) {
      card.addEventListener('mousemove', function (e) {
        var rect = card.getBoundingClientRect();
        var x = (e.clientX - rect.left) / rect.width - 0.5;
        var y = (e.clientY - rect.top) / rect.height - 0.5;
        card.style.transform = 'perspective(600px) rotateY(' + (x * 8) + 'deg) rotateX(' + (-y * 8) + 'deg) translateY(-4px)';
      });
      card.addEventListener('mouseleave', function () {
        card.style.transform = '';
      });
    });
  }

  /* ─── Stat Underline Animation ─── */

  function initStatUnderline() {
    var stats = document.querySelectorAll('.sf-trust-stat-num');
    if (!stats.length) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          setTimeout(function () {
            entry.target.classList.add('sf-stat-animated');
          }, 400);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.5 });

    stats.forEach(function (el) { observer.observe(el); });
  }

  /* ─── Smooth scroll for anchor links ─── */

  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        var target = document.querySelector(link.getAttribute('href'));
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }

  /* ─── MODAL SYSTEM ─── */

  window.sfOpenModal = function (id) {
    var overlay = document.getElementById('sf-modal-' + id);
    if (!overlay) return;
    overlay.classList.add('sf-modal-open');
    document.body.style.overflow = 'hidden';
    if (id === 'storefront') {
      sfCalc();
      overlay.querySelectorAll('.sf-est-range').forEach(sfUpdateRange);
    }
    if (id === 'fundraiser') {
      sfFundRender();
      sfFundCalc();
      var soldRange = document.getElementById('sf-fund-sold');
      if (soldRange) sfUpdateRange(soldRange);
    }
  };

  window.sfCloseModal = function (id) {
    var overlay = document.getElementById('sf-modal-' + id);
    if (!overlay) return;
    overlay.classList.remove('sf-modal-open');
    document.body.style.overflow = '';
  };

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      ['storefront', 'fundraiser'].forEach(function (id) {
        var el = document.getElementById('sf-modal-' + id);
        if (el) el.classList.remove('sf-modal-open');
      });
      document.body.style.overflow = '';
    }
  });

  document.addEventListener('click', function (e) {
    if (e.target && e.target.classList.contains('sf-modal-overlay')) {
      e.target.classList.remove('sf-modal-open');
      document.body.style.overflow = '';
    }
  });

  /* ─── STOREFRONT ESTIMATOR LOGIC ─── */

  window.sfSelectType = function (btn) {
    document.querySelectorAll('.sf-est-type-btn').forEach(function (b) {
      b.classList.remove('sf-est-type-btn--active');
    });
    btn.classList.add('sf-est-type-btn--active');
    var size = parseInt(btn.dataset.size, 10);
    var rate = parseInt(btn.dataset.rate, 10);
    var audEl = document.getElementById('sf-audience');
    var convEl = document.getElementById('sf-conversion');
    if (audEl) { audEl.value = size; sfUpdateRange(audEl); }
    if (convEl) { convEl.value = rate; sfUpdateRange(convEl); }
    sfCalc();
  };

  function sfUpdateRange(input) {
    var min = parseFloat(input.min);
    var max = parseFloat(input.max);
    var val = parseFloat(input.value);
    var pct = ((val - min) / (max - min)) * 100;
    input.style.background = 'linear-gradient(to right,#3b82f6 0%,#3b82f6 ' + pct + '%,#e5e7eb ' + pct + '%,#e5e7eb 100%)';
  }

  window.sfCalc = function () {
    var audience = parseInt(document.getElementById('sf-audience').value, 10) || 200;
    var conversion = parseInt(document.getElementById('sf-conversion').value, 10) || 40;
    var aov = parseInt(document.getElementById('sf-aov').value, 10) || 65;
    var margin = parseInt(document.getElementById('sf-margin').value, 10) || 40;

    document.getElementById('sf-audience-val').textContent = audience.toLocaleString();
    document.getElementById('sf-conversion-val').textContent = conversion + '%';
    document.getElementById('sf-aov-val').textContent = '$' + aov;
    document.getElementById('sf-margin-val').textContent = margin + '%';

    ['sf-audience', 'sf-conversion', 'sf-aov', 'sf-margin'].forEach(function (id) {
      var el = document.getElementById(id);
      if (el) sfUpdateRange(el);
    });

    var buyers = Math.round(audience * (conversion / 100));
    var revenue = buyers * aov;
    var profit = Math.round(revenue * (margin / 100));
    var profitPerOrder = Math.round(aov * (margin / 100));

    document.getElementById('sf-result-revenue').textContent = '$' + revenue.toLocaleString();
    document.getElementById('sf-result-profit').textContent = '$' + profit.toLocaleString();
    document.getElementById('sf-result-buyers').textContent = buyers.toLocaleString() + ' buyers × $' + aov + ' avg order';
    document.getElementById('sf-result-per-order').textContent = '$' + profitPerOrder + ' profit per order · ' + margin + '% margin';
  };

  /* ─── FUNDRAISER ESTIMATOR LOGIC ─── */

  var SF_FUND_CAMPAIGN = 'pod'; // 'pod' or 'bulk'
  var SF_FUND_TIER = 'avg';

  // podCost = standard (print on demand); bulkCost = bulk order rate
  var SF_FUND_PRODUCTS = [
    { id: 1,  name: 'Premium Unisex Tee',      podCost: 18.34, bulkCost: 13.82, low: 24.99, avg: 27.99, high: 32.99, price: 27.99 },
    { id: 2,  name: 'Classic Unisex Tee',      podCost: 17.02, bulkCost: 12.77, low: 22.99, avg: 24.99, high: 29.99, price: 24.99 },
    { id: 3,  name: 'Softstyle Hoodie',        podCost: 30.00, bulkCost: 22.50, low: 34.99, avg: 37.99, high: 44.99, price: 37.99 },
    { id: 4,  name: 'Crewneck Sweatshirt',     podCost: 28.25, bulkCost: 21.19, low: 35.99, avg: 39.99, high: 46.99, price: 39.99 },
    { id: 5,  name: 'Long Sleeve Performance', podCost: 33.00, bulkCost: 26.50, low: 38.99, avg: 42.99, high: 49.99, price: 42.99 },
    { id: 6,  name: 'Youth Tee',               podCost: 16.32, bulkCost: 12.24, low: 21.99, avg: 24.99, high: 28.99, price: 24.99 },
    { id: 7,  name: '20 oz Tumbler',           podCost: 17.00, bulkCost: 13.75, low: 22.99, avg: 26.99, high: 31.99, price: 26.99 },
    { id: 8,  name: '30 oz Tumbler',           podCost: 19.00, bulkCost: 14.95, low: 24.99, avg: 28.99, high: 34.99, price: 28.99 },
    { id: 9,  name: '20 oz Water Bottle',      podCost: 17.00, bulkCost: 12.75, low: 22.99, avg: 26.99, high: 31.99, price: 26.99 },
    { id: 10, name: '32 oz Water Bottle',      podCost: 20.00, bulkCost: 15.00, low: 29.99, avg: 34.99, high: 39.99, price: 34.99 },
  ];

  function sfFundActiveCost(p) {
    return SF_FUND_CAMPAIGN === 'bulk' ? p.bulkCost : p.podCost;
  }

  window.sfSetCampaign = function (btn) {
    document.querySelectorAll('.sf-fund-campaign-btn').forEach(function (b) {
      b.classList.remove('sf-fund-campaign-btn--active');
    });
    btn.classList.add('sf-fund-campaign-btn--active');
    SF_FUND_CAMPAIGN = btn.dataset.campaign;
    // Re-apply current tier prices (sell prices stay, costs change)
    sfFundRender();
    sfFundCalc();
  };

  window.sfSetTier = function (btn) {
    document.querySelectorAll('.sf-fund-tier-btn').forEach(function (b) {
      b.classList.remove('sf-fund-tier-btn--active');
    });
    btn.classList.add('sf-fund-tier-btn--active');
    SF_FUND_TIER = btn.dataset.tier;
    SF_FUND_PRODUCTS.forEach(function (p) {
      p.price = p[SF_FUND_TIER];
    });
    sfFundRender();
    sfFundCalc();
  };

  window.sfFundUpdatePrice = function (id, val) {
    var p = SF_FUND_PRODUCTS.find(function (x) { return x.id === id; });
    if (!p) return;
    var cost = sfFundActiveCost(p);
    p.price = Math.max(cost, parseFloat(val) || cost);
    sfFundCalc();
    var profitEl = document.getElementById('sf-fund-profit-' + id);
    if (profitEl) {
      var profit = p.price - cost;
      profitEl.textContent = '$' + profit.toFixed(2);
      profitEl.className = 'sf-fund-profit' + (profit <= 0 ? ' sf-fund-profit--neg' : '');
    }
  };

  function sfFundRender() {
    var container = document.getElementById('sf-fund-products');
    if (!container) return;
    container.innerHTML = SF_FUND_PRODUCTS.map(function (p) {
      var cost = sfFundActiveCost(p);
      var profit = p.price - cost;
      return '<div class="sf-fund-table-row">' +
        '<span class="sf-fund-product-name">' + p.name + '</span>' +
        '<span class="sf-fund-cost">$' + cost.toFixed(2) + '</span>' +
        '<span class="sf-fund-price-input"><span>$</span><input type="number" value="' + p.price.toFixed(2) + '" min="' + cost.toFixed(2) + '" step="0.50" onchange="sfFundUpdatePrice(' + p.id + ',this.value)" /></span>' +
        '<span class="sf-fund-profit' + (profit <= 0 ? ' sf-fund-profit--neg' : '') + '" id="sf-fund-profit-' + p.id + '">$' + profit.toFixed(2) + '</span>' +
        '</div>';
    }).join('');
  }

  window.sfFundCalc = function () {
    var sold = parseInt(document.getElementById('sf-fund-sold').value, 10) || 50;
    var soldEl = document.getElementById('sf-fund-sold-val');
    if (soldEl) soldEl.textContent = sold + ' items';

    var soldRange = document.getElementById('sf-fund-sold');
    if (soldRange) sfUpdateRange(soldRange);

    var avgProfit = SF_FUND_PRODUCTS.reduce(function (s, p) { return s + (p.price - sfFundActiveCost(p)); }, 0) / SF_FUND_PRODUCTS.length;
    var low = Math.round(sold * avgProfit * 0.8);
    var high = Math.round(sold * avgProfit * 1.2);

    var resultEl = document.getElementById('sf-fund-result');
    var subEl = document.getElementById('sf-fund-result-sub');
    if (resultEl) resultEl.textContent = '$' + low.toLocaleString() + ' – $' + high.toLocaleString();
    if (subEl) subEl.textContent = 'Based on ' + sold + ' items sold · $' + avgProfit.toFixed(2) + ' avg profit/item';
  };

  /* ─── INIT ─── */

  function init() {
    initReveal();
    initCounters();
    initNav();
    initFaq();
    initHeroCycle();
    initSmoothScroll();
    initStickyBar();
    initHamburger();
    initCardTilt();
    initStatUnderline();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
